/**
 * Copyright 2024 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */
import {Reducer} from 'redux';

import {ScreensActions} from 'store/action/screens';
import {DirectionType, ITableSortSearch} from 'components/table';
import {SET_SCREEN_PROPS} from 'store/action/screens';

export enum StoreScreensType {
  Channels = 'Channels',
  ChannelMessages = 'ChannelMessages',
  ChannelPublishHistory = 'ChannelPublishHistory',
  ChannelForkHistory = 'ChannelForkHistory',
  Rooms = 'Rooms',
  RoomMessages = 'RoomMessages',
}

export type ChannelsProps = ITableSortSearch;
export type ChannelMessagesProps = ITableSortSearch;
export type ChannelPublishHistoryProps = ITableSortSearch;
export type ChannelForkHistoryProps = ITableSortSearch;
export type RoomsProps = ITableSortSearch;
export type RoomMessagesProps = ITableSortSearch;

export interface IScreensState {
  [StoreScreensType.Channels]: ChannelsProps;
  [StoreScreensType.ChannelMessages]: ChannelMessagesProps;
  [StoreScreensType.ChannelPublishHistory]: ChannelPublishHistoryProps;
  [StoreScreensType.ChannelForkHistory]: ChannelForkHistoryProps;
  [StoreScreensType.Rooms]: RoomsProps;
  [StoreScreensType.RoomMessages]: RoomMessagesProps;
}

export type ScreenDataProps =
  | ChannelsProps
  | ChannelMessagesProps
  | ChannelPublishHistoryProps
  | ChannelForkHistoryProps
  | RoomsProps
  | RoomMessagesProps;

const initialScreensState: IScreensState = {
  [StoreScreensType.Channels]: {
    sortColumn: 'created',
    sortDirection: DirectionType.Asc,
    searchValue: ''
  },
  [StoreScreensType.ChannelMessages]: {
    sortColumn: 'timestamp',
    sortDirection: DirectionType.Desc,
    searchValue: ''
  },
  [StoreScreensType.ChannelPublishHistory]: {
    sortColumn: 'StartTimestamp',
    sortDirection: DirectionType.Asc,
    searchValue: ''
  },
  [StoreScreensType.ChannelForkHistory]: {
    sortColumn: 'Timestamp',
    sortDirection: DirectionType.Desc,
    searchValue: ''
  },
  [StoreScreensType.Rooms]: {
    sortColumn: 'created',
    sortDirection: DirectionType.Asc,
    searchValue: ''
  },
  [StoreScreensType.RoomMessages]: {
    sortColumn: 'timestamp',
    sortDirection: DirectionType.Desc,
    searchValue: ''
  }
};
const screensReducer: Reducer<Readonly<IScreensState>, ScreensActions> = (
  state = initialScreensState,
  action: ScreensActions
) => {
  switch (action.type) {
    case SET_SCREEN_PROPS:
      return {
        ...state,
        [action.payload.screen]: {
          ...state[action.payload.screen],
          ...action.payload.data
        }
      };
    default:
      return state;
  }
};

export default screensReducer;